import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";

type SecretNumberDisplayProps = {
  value: string;
};

function SecretNumberDisplay({ value }: SecretNumberDisplayProps) {
  const theme = useTheme();
  return (
    <Stack direction="row" gap={1} justifyContent="space-between">
      {Array.from({ length: 6 }, (_, i) => {
        if (!value[i]) {
          return (
            <Box
              key={"secret" + i}
              height={48}
              width={48}
              bgcolor="#F5F5F5"
              borderRadius={2}
            />
          );
        }
        return (
          <Stack
            key={"secret" + i}
            height={48}
            width={48}
            bgcolor={theme.palette.primary.main}
            borderRadius={2}
            justifyContent="center"
            alignItems="center"
          >
            <Box bgcolor="white" borderRadius="50%" height={12} width={12} />
          </Stack>
        );
      })}
    </Stack>
  );
}

export default SecretNumberDisplay;
